export interface ArticleItem {
  id: string;
  title: string;
  section: "news" | "star";
  tags: string[];
  date: string;
  cover: string;
  summary: string;
  content: string;
  relatedCategory: "movie" | "tv" | "star-news";
}

export const articleList: ArticleItem[] = [
  {
    id: "a-01",
    title: "多部现实题材新作集中定档，暑期档格局迎来新变化",
    section: "news",
    tags: ["影视资讯", "档期"],
    date: "2024-09-18",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20cinema%20marquee%20at%20dusk%20with%20soft%20warm%20orange%20glow%20and%20clean%20grey%20urban%20background%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20cover%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-01&orientation=landscape",
    summary: "多家影视公司近日陆续公布暑期档排片计划，多部现实题材作品集中亮相，为观众提供了更丰富的选择。",
    content: "随着暑期档临近，多家影视公司近日陆续公布排片计划。与往年相比，今年定档作品中现实题材的比例明显上升，涵盖都市生活、家庭情感与行业职场等多个方向。业内人士认为，观众对贴近生活的故事接受度持续提高，题材结构正在发生变化。",
    relatedCategory: "movie",
  },
  {
    id: "a-02",
    title: "古装悬疑剧热度走高，考究的美术设计成为讨论焦点",
    section: "news",
    tags: ["电视剧", "热播"],
    date: "2024-09-16",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20ancient%20chinese%20lanterns%20and%20rooftops%20silhouette%20at%20night%20with%20warm%20amber%20light%20and%20ink%20grey%20background%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-02&orientation=landscape",
    summary: "近期多部古装悬疑剧集受到关注，观众对服化道与场景的精致程度讨论热烈。",
    content: "近期上线的多部古装悬疑剧集热度持续走高，除剧情之外，考究的服化道与场景搭建成为观众讨论的焦点。有观众表示，细节上的用心让故事更具沉浸感。制作团队也透露，为还原特定年代的城市风貌，前期做了大量资料考证。",
    relatedCategory: "tv",
  },
  {
    id: "a-03",
    title: "青年导演扶持计划公布新一批入选项目",
    section: "news",
    tags: ["产业", "扶持"],
    date: "2024-09-12",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20film%20clapperboard%20and%20a%20storyboard%20on%20a%20warm%20clean%20desk%2C%20soft%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-03&orientation=landscape",
    summary: "新一批青年导演扶持项目正式公布，入选作品题材多元，将于年内陆续进入拍摄阶段。",
    content: "一项面向青年导演的扶持计划近日公布了新一批入选项目。本批次入选作品题材涵盖剧情、纪录与动画等多个方向，团队整体较为年轻。主办方表示，希望通过资金与制作资源的支持，帮助更多有想法的创作者把作品带到观众面前。",
    relatedCategory: "movie",
  },
  {
    id: "a-04",
    title: "暑期动画电影口碑回暖，亲子观影需求持续释放",
    section: "news",
    tags: ["影视资讯", "动画"],
    date: "2024-09-09",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20colorful%20balloons%20and%20a%20cinema%20screen%20in%20warm%20sunlit%20tone%2C%20playful%20orange%20and%20soft%20grey%20palette%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic&width=900&height=600&seq=pcm-a-04&orientation=landscape",
    summary: "多部动画电影在暑期档获得不错口碑，家庭观众成为重要观影群体。",
    content: "今年暑期档多部动画电影表现稳健，口碑较去年有所回暖。从数据来看，亲子家庭是这些作品的主要观众群体，周末场次尤为集中。有从业者指出，动画作品在表达上的包容性，使其成为连接不同年龄观众的良好载体。",
    relatedCategory: "movie",
  },
  {
    id: "a-05",
    title: "流媒体平台加码自制内容，短剧集成新增长点",
    section: "news",
    tags: ["产业", "流媒体"],
    date: "2024-09-05",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20smart%20tv%20screen%20and%20streaming%20interface%20blocks%20in%20warm%20evening%20room%2C%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-05&orientation=landscape",
    summary: "多家流媒体平台近期公布内容计划，自制短剧集被视为新的增长方向。",
    content: "多家流媒体平台近期公布了新一轮内容计划，其中自制剧集投入继续增加。值得注意的是，篇幅更短、节奏更快的短剧集成为不少平台的重点方向。分析认为，这既顺应了移动端的观看习惯，也为新题材提供了试水空间。",
    relatedCategory: "tv",
  },
  {
    id: "a-06",
    title: "经典作品修复重映，老电影如何打动新观众",
    section: "news",
    tags: ["影视资讯", "修复"],
    date: "2024-09-02",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20an%20old%20film%20reel%20and%20projector%20light%20beam%20in%20warm%20sepia%20tone%2C%20orange%20and%20grey%20palette%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic&width=900&height=600&seq=pcm-a-06&orientation=landscape",
    summary: "一批经过修复的经典影片陆续重返大银幕，吸引了不少年轻观众走进影院。",
    content: "一批经过数字化修复的经典影片近期陆续重返大银幕。修复团队在保留原有质感的基础上，提升了画面与声音的表现力。不少年轻观众表示，虽然年代久远，但作品中对情感的刻画依然能够引起共鸣。",
    relatedCategory: "movie",
  },
  {
    id: "a-07",
    title: "剧集出口题材拓宽，现实故事获得更多海外关注",
    section: "news",
    tags: ["产业", "出海"],
    date: "2024-08-29",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20world%20map%20with%20connected%20light%20lines%20in%20warm%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-07&orientation=landscape",
    summary: "越来越多现实题材剧集走向海外市场，生活化的表达成为跨文化传播的桥梁。",
    content: "近年来，越来越多现实题材剧集走向海外市场，覆盖的题材范围也在不断拓宽。与宏大叙事相比，聚焦普通人生活的故事更容易跨越文化差异引发共鸣。业内认为，内容的真实感与情感的共通性，是作品获得海外关注的关键。",
    relatedCategory: "tv",
  },
  {
    id: "a-08",
    title: "影视基地升级数字化拍摄流程，制作效率显著提升",
    section: "news",
    tags: ["产业", "技术"],
    date: "2024-08-26",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20virtual%20film%20production%20stage%20with%20soft%20lighting%20grids%20in%20warm%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-08&orientation=landscape",
    summary: "多地影视基地推进数字化拍摄流程建设，从前期预演到后期管理均有改善。",
    content: "多地影视基地正推进数字化拍摄流程的建设，从前期虚拟预演到现场管理、后期制作均有明显改善。制作方表示，数字化工具帮助团队在开拍前更清晰地规划画面，减少了反复调整带来的时间与成本消耗。",
    relatedCategory: "movie",
  },
  {
    id: "a-09",
    title: "综艺与剧集联动增多，内容生态走向融合",
    section: "news",
    tags: ["影视资讯", "综艺"],
    date: "2024-08-22",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20stage%20spotlight%20and%20screen%20icon%20in%20warm%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-09&orientation=landscape",
    summary: "综艺与剧集之间的联动越来越常见，不同内容形态正在相互借力。",
    content: "近段时间，综艺与剧集之间的联动案例明显增多。有的剧集借综艺完成预热，有的综艺则围绕热门剧集展开衍生内容。业内人士表示，这种融合有助于延长内容热度周期，也让观众获得更连贯的观看体验。",
    relatedCategory: "tv",
  },
  {
    id: "a-10",
    title: "纪录片创作持续升温，普通人故事成为主角",
    section: "news",
    tags: ["产业", "纪录片"],
    date: "2024-08-18",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20documentary%20camera%20and%20a%20quiet%20rural%20landscape%20in%20warm%20sunset%20tone%2C%20orange%20and%20grey%20palette%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic&width=900&height=600&seq=pcm-a-10&orientation=landscape",
    summary: "越来越多的纪录片把镜头对准普通人，真实生活的质感打动人心。",
    content: "近年来纪录片创作持续升温，题材从自然地理延伸到普通人的日常生活。创作者更倾向于长时间跟拍，捕捉真实的情感瞬间。观众反馈显示，质朴真诚的表达往往比刻意设计更有力量。",
    relatedCategory: "movie",
  },
  {
    id: "a-11",
    title: "剧本创作工作坊落地多城，新人编剧迎来更多机会",
    section: "news",
    tags: ["产业", "创作"],
    date: "2024-08-14",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20writing%20desk%20with%20a%20notebook%20and%20warm%20lamp%20in%20a%20cozy%20room%2C%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-11&orientation=landscape",
    summary: "面向新人编剧的创作工作坊在多个城市落地，为创作者提供实战训练与行业交流机会。",
    content: "面向新人编剧的创作工作坊近期在多个城市陆续举办，内容涵盖结构搭建、人物塑造与项目提案等环节。参与者在导师指导下完成短篇练习，并与制作方进行交流。主办方希望借此为行业输送更多新鲜创作力量。",
    relatedCategory: "movie",
  },
  {
    id: "a-12",
    title: "影院推出多样化观影服务，提升观众到店体验",
    section: "news",
    tags: ["影视资讯", "影院"],
    date: "2024-08-10",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20cozy%20cinema%20lobby%20with%20warm%20lights%20and%20seats%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-12&orientation=landscape",
    summary: "为提升到店体验，多家影院推出主题影厅与多样化观影服务。",
    content: "为提升观众的到店体验，多家影院近期推出了主题影厅、特色小食与映后交流等多样化服务。有影院负责人表示，除了影片本身，整体氛围与服务细节同样会影响观众的复购意愿。",
    relatedCategory: "movie",
  },
  {
    id: "a-13",
    title: "青年演员谈新剧角色：为人物做足功课是一场修行",
    section: "star",
    tags: ["采访"],
    date: "2024-09-17",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20portrait%20style%20illustration%20of%20a%20warm%20spotlight%20and%20an%20empty%20stage%20chair%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-13&orientation=landscape",
    summary: "在新剧中挑大梁的青年演员分享了角色准备过程，称细节功课让自己受益良多。",
    content: "在新剧中担任主角的青年演员近日接受采访，谈到为角色所做的准备。他透露，为了贴近人物状态，提前进行了长时间的实地体验与资料研读。在他看来，做足功课不仅是塑造角色的基础，也是一次难得的自我修行。",
    relatedCategory: "star-news",
  },
  {
    id: "a-14",
    title: "主演阵容现身新剧发布会，现场互动气氛热烈",
    section: "star",
    tags: ["活动"],
    date: "2024-09-14",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20press%20conference%20stage%20with%20warm%20lights%20and%20mics%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-14&orientation=landscape",
    summary: "新剧发布会现场，多位主演集体亮相并与观众互动，气氛轻松热烈。",
    content: "新剧发布会日前举行，多位主演集体亮相。主创团队分享了拍摄期间的趣事，并与到场观众进行了互动。现场气氛轻松热烈，不少观众表示对即将上线的剧集更加期待。",
    relatedCategory: "star-news",
  },
  {
    id: "a-15",
    title: "演员片场花絮曝光，幕后日常引网友热议",
    section: "star",
    tags: ["片场"],
    date: "2024-09-11",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20backstage%20film%20set%20with%20warm%20work%20lights%20and%20equipment%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-15&orientation=landscape",
    summary: "一组片场花絮照片释出，演员幕后的认真与幽默同时被镜头记录。",
    content: "一组片场花絮照片近日释出，记录了演员在拍摄间隙的状态。镜头里既有反复打磨走位的认真，也有与工作人员打趣的轻松时刻。网友表示，这些幕后片段让人对作品多了一份亲切感。",
    relatedCategory: "star-news",
  },
  {
    id: "a-16",
    title: "实力派演员回归小荧幕，坦言更看重故事本身",
    section: "star",
    tags: ["采访"],
    date: "2024-09-08",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20quiet%20reading%20corner%20with%20warm%20lamp%20and%20script%20pages%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-16&orientation=landscape",
    summary: "多年专注电影的演员回归剧集，表示挑剧本时更看重故事与人物的真实感。",
    content: "一位多年活跃于大银幕的演员近期回归剧集拍摄。谈及选剧标准，他表示自己更看重故事是否真诚、人物是否立得住。他认为，无论篇幅长短，好故事始终是打动观众的核心。",
    relatedCategory: "star-news",
  },
  {
    id: "a-17",
    title: "剧组探班：一场夜戏背后，是上百人的默契配合",
    section: "star",
    tags: ["片场"],
    date: "2024-09-04",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20night%20film%20set%20with%20warm%20key%20light%20and%20crew%20silhouettes%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-17&orientation=landscape",
    summary: "探班剧组夜戏拍摄，一个镜头背后凝聚着多个岗位的紧密协作。",
    content: "在剧组夜戏拍摄现场，一个看似简单的镜头往往需要灯光、摄影、美术与演员等多个岗位的紧密配合。工作人员透露，为捕捉理想的画面，团队常常反复调整。当天的拍摄持续到凌晨，但现场始终井然有序。",
    relatedCategory: "star-news",
  },
  {
    id: "a-18",
    title: "演员参与公益活动，呼吁关注乡村儿童阅读",
    section: "star",
    tags: ["活动"],
    date: "2024-08-31",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20stack%20of%20books%20and%20a%20warm%20sunbeam%20in%20a%20simple%20room%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-18&orientation=landscape",
    summary: "多位演员参与阅读公益行动，为乡村学校募集图书并录制朗读音频。",
    content: "多位演员近期参与了一项面向乡村学校的阅读公益行动，为孩子们募集图书，并录制了朗读音频。参与者表示，希望以力所能及的方式，让更多孩子感受到阅读的乐趣。活动主办方称，首批图书已陆续送达。",
    relatedCategory: "star-news",
  },
  {
    id: "a-19",
    title: "关于合作传闻，双方工作室均未作出回应",
    section: "star",
    tags: ["绯闻"],
    date: "2024-08-27",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20two%20overlapping%20warm%20circles%20and%20a%20soft%20bokeh%20background%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-19&orientation=landscape",
    summary: "近日网络流传两位演员的合作传闻，截至发稿，双方工作室均未对此作出回应。",
    content: "近日网络上流传两位演员将合作新项目的传闻，引发网友讨论。截至发稿，双方工作室均未就相关消息作出回应。业内人士提醒，此类传闻仍需以官方信息为准，理性看待。",
    relatedCategory: "star-news",
  },
  {
    id: "a-20",
    title: "演员新片造型首度公开，颠覆以往形象引期待",
    section: "star",
    tags: ["花絮"],
    date: "2024-08-23",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20costume%20rack%20and%20warm%20vanity%20mirror%20lights%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-20&orientation=landscape",
    summary: "演员在新片中的造型首次公开，与以往风格差异明显，引发观众期待。",
    content: "一位演员在新片中的造型近日首次公开，与以往塑造的形象差异明显。造型团队介绍，为贴合角色设定，在服装与妆发上做了多轮调整。网友表示，这种突破让人对影片更加好奇。",
    relatedCategory: "star-news",
  },
  {
    id: "a-21",
    title: "资深演员谈行业变化：好作品永远需要耐心",
    section: "star",
    tags: ["采访"],
    date: "2024-08-19",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20seasoned%20stage%20with%20warm%20curtain%20and%20a%20single%20chair%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-21&orientation=landscape",
    summary: "入行多年的演员分享从业心得，认为创作环境的快慢变化都需要以耐心应对。",
    content: "一位入行多年的演员在访谈中分享了自己的从业心得。他观察到行业节奏近年明显加快，但在他看来，好作品依然需要时间与耐心去打磨。他鼓励年轻从业者在忙碌中保留对创作本身的敬畏。",
    relatedCategory: "star-news",
  },
  {
    id: "a-22",
    title: "剧组成员集体为角色庆生，片场暖意十足",
    section: "star",
    tags: ["活动"],
    date: "2024-08-15",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20small%20celebration%20table%20with%20warm%20candles%20and%20soft%20light%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-22&orientation=landscape",
    summary: "剧组利用拍摄间隙为角色举行了一场简单的庆生活动，片场气氛温馨。",
    content: "在紧张的拍摄间隙，剧组为剧中角色准备了一场简单的庆生活动。现场布置质朴，却让整个片场充满暖意。工作人员表示，这样的时刻有助于缓解大家的疲惫，也让团队更有凝聚力。",
    relatedCategory: "star-news",
  },
  {
    id: "a-23",
    title: "演员分享角色塑造方法：从生活细节中寻找灵感",
    section: "star",
    tags: ["采访"],
    date: "2024-08-11",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20notebook%20sketch%20and%20a%20cup%20of%20coffee%20on%20a%20warm%20desk%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-23&orientation=landscape",
    summary: "演员在采访中分享了自己从日常生活中取材、丰富角色层次的方法。",
    content: "一位演员在采访中谈到自己的角色塑造方法，习惯从日常生活的细节中寻找灵感。他会为人物建立详细的生活背景，小到说话习惯与走路的姿态。他认为，这些看似微小的设计，恰恰是让角色鲜活的关键。",
    relatedCategory: "star-news",
  },
  {
    id: "a-24",
    title: "幕后造型团队揭秘：一套戏服如何诞生",
    section: "star",
    tags: ["花絮"],
    date: "2024-08-07",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20editorial%20illustration%20of%20a%20fabric%20swatch%20board%20and%20sewing%20tools%20with%20warm%20light%20in%20orange%20and%20grey%20tones%2C%20minimal%20flat%20style%2C%20elegant%20negative%20space%2C%20magazine%20aesthetic%2C%20harmonious%20warm%20palette&width=900&height=600&seq=pcm-a-24&orientation=landscape",
    summary: "造型团队揭秘一套戏服的制作流程，从考据到成衣往往需要数周时间。",
    content: "造型团队近日分享了戏服制作的全过程，从资料考据、设计草图到面料采购与打版成衣，一套戏服的诞生往往需要数周时间。团队成员表示，服装不仅要符合角色设定，也要考虑拍摄中的舒适度与耐用性。",
    relatedCategory: "star-news",
  },
];